import axios from "axios";
import {
 
    PARTICULAR_PRODUCT_REQUEST,
    PARTICULAR_PRODUCT_SUCCESS ,
    PARTICULAR_PRODUCT_FAIL,

    PARTICULAR_PRODUCT_DETAILS_REQUEST,
    PARTICULAR_PRODUCT_DETAILS_SUCCESS ,
    PARTICULAR_PRODUCT_DETAILS_FAIL 


} from "../constants/categoryConstants";
import { BASE_URL, SINGLEPRODUCT_URL } from "../api";

export const listSingleProduct = (id) => async (dispatch) => {
  try {
    dispatch({ type: PARTICULAR_PRODUCT_REQUEST });
    const { data } = await axios.get(BASE_URL+SINGLEPRODUCT_URL+`${id}`+'/');
    dispatch({
      type: PARTICULAR_PRODUCT_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: PARTICULAR_PRODUCT_FAIL,
      
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.message,
    });
  }
};


export const listSingleProductDetails =(id) => async (dispatch)=>{
  try{
      dispatch({type:PARTICULAR_PRODUCT_DETAILS_REQUEST})
      const {data} = await axios.get(`/api/products/${id}`)
      dispatch({
          type:PARTICULAR_PRODUCT_DETAILS_SUCCESS,
          payload:data
      })
  }
  catch(error){
      dispatch({
          type:PARTICULAR_PRODUCT_DETAILS_FAIL,
          payload:error.response && error.response.data.detail
          ? error.response.data.detail
          :error.message,
      })
  }
}